export default __webpack_public_path__ + "static/casablanca-2-4fd1cf5c872766045715a8c96376e470.jpg";